import { Auth } from 'aws-amplify';
import {
  trackSignUp,
  SignUpType,
  setUrlSignUpParamsInLocalStorage,
} from '../../../../../utils';
import { SignUpArugments } from '../types/signup-arguments';

export async function signUp({
  email,
  password,
  tel,
  firstName,
  lastName,
  findUs,
  urlParams,
  trackEvent,
}: SignUpArugments) {
  setUrlSignUpParamsInLocalStorage();
  const signupInfo = {
    username: email,
    password,
    attributes: {
      phone_number: tel,
      'custom:first_name': firstName,
      'custom:last_name': lastName,
      'custom:find_us': findUs,
      'custom:completed_onboarding': '0',
      'custom:onboarding_page': '1',
      'custom:url_params_on_signup': JSON.stringify(urlParams),
    },
  };
  await Auth.signUp(signupInfo);
  trackSignUp(firstName, lastName, email, null, SignUpType.MANUAL, trackEvent);
}
